import { get, post } from '../services/common/common.service';
import { warrantyEndPoints } from '../constants/endpoint';

export const autocompleteSearch = (payload) =>
  post(warrantyEndPoints.warrantySearch, payload);

export const searchWarranty = (payload) =>
  post(warrantyEndPoints.warrantySearch, payload);

export const fetchWarrantyDetail = (payload) =>
  get(
    `${warrantyEndPoints.warrantyDetail}?warrantyPartNumber=${payload}`,
    payload
  );

export const fetchSerialNoHistory = (payload) =>
  get(`${warrantyEndPoints.serialNoHistory}?warrantyId=${payload}`, payload);

export const fetchEntitlement = (payload) =>
  get(`${warrantyEndPoints.entitlement}?warrantyId=${payload}`, payload);
